import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Document, PDFViewer, pdf } from "@react-pdf/renderer";
import { Check } from "lucide-react";
import axios from "axios";
import { useCookies } from "react-cookie";
import Page1 from "./pages/page-1";
import Page2 from "./pages/page-2";
import Page3 from "./pages/page-3";
import Page4 from "./pages/page-4";
import Page5 from "./pages/page-5";
import Page6 from "./pages/page-6";
import { useContract } from "../../../../../../../../provider/ContractProvider";
import { distributionUrl } from "../../../../../../../Config/url";

const NormalLicense = forwardRef((_, ref) => {
  const { data, setData } = useContract();
  const [checked, setChecked] = useState(false);
  const [cookie] = useCookies();
  const viewerRef = useRef(null);

  const axiosConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: "Bearer " + cookie.mmusic_token,
      "Publisher-Id": JSON.parse(localStorage.getItem("Current-Publisher"))?.id,
    },
  };

  const handleCheckedChange = () => {
    setChecked((prevChecked) => {
      const newChecked = !prevChecked;
      setData((prevData) => ({
        ...prevData,
        is_updatable: !newChecked,
      }));
      return newChecked;
    });
  };

  const generatePDF = async () => {
    const formData = new FormData();
    const pages = [
      { component: <Page1 data={data} />, fileName: "license_page_1.pdf" },
      { component: <Page2 />, fileName: "license_page_2.pdf" },
      { component: <Page3 data={data} />, fileName: "license_page_3.pdf" },
      { component: <Page4 />, fileName: "license_page_4.pdf" },
      { component: <Page5 />, fileName: "license_page_5.pdf" },
      { component: <Page6 data={data} />, fileName: "license_page_6.pdf" },
    ];

    for (let i = 0; i < pages.length; i++) {
      const pageDocument = <Document>{pages[i].component}</Document>;

      const generatedBlob = await pdf(pageDocument).toBlob();
      formData.append(`files[${i}]`, generatedBlob, `license-${i + 1}.pdf`);
    }

    try {
      const response = await axios.post(
        distributionUrl + "media/panel/files:many",
        formData,
        axiosConfig
      );

      if (response.status === 200) {
        setData((prevData) => ({
          ...prevData,
          license_documents: response.data,
        }));
      }
    } catch (err) {
      console.error("PDF илгээхэд алдаа гарлаа:", err);
    }
  };

  useImperativeHandle(ref, () => ({
    handleGeneratePDF: generatePDF,
  }));

  return (
    <div className="relative h-full">
      <div className="border rounded-xl relative mx-6 py-3 shadow-xl h-full">
        <div className="px-12 overflow-y-auto">
          <PDFViewer width="100%" height="452px">
            <Document>
              <Page1 data={data} />
              <Page2 />
              <Page3 data={data} />
              <Page4 />
              <Page5 />
              <Page6 data={data} />
            </Document>
          </PDFViewer>
        </div>
        <div className="flex w-full">
          <div
            className={`${
              checked ? "opacity-100" : "opacity-50"
            } flex items-center gap-4 px-6 py-3 `}
          >
            <div>
              <button
                className={`w-5 h-5 rounded-[2px] flex items-center justify-center ${
                  checked ? "bg-mmusic text-white" : "border-2 border-[#D0D5DD]"
                }`}
                onClick={() => handleCheckedChange(data)}
              >
                {checked && <Check size={14} strokeWidth={4} />}
              </button>
            </div>
            <p className="italic text-[10px] leading-4">
              Гэрээний бүх нөхцөлтэй бүрэн танилцсаны дараа баталгаажуулах
              боломжтой. "Баталгаажуулах" товчийг дарснаар Та үйлчилгээний
              нөхцөл болон гэрээний мэдээлэл үнэн зөв болохыг хүлээн зөвшөөрч,
              баталж байгаагаа илэрхийлнэ.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default NormalLicense;
